import { FormFieldDefinition } from '@publishing-engine/domain/types/article';

export type ArticleTypeConfigField = {
  id: string;
  field: string;
  kind: string;
  required: boolean;
  validations: unknown;
  labels: unknown;
  parentRowId?: string;
};

export type SourceFieldOption = {
  id: string;
  field: string;
  kind: string;
  required: boolean;
  validations: unknown;
  labels: unknown;
  dependentFieldFromReference?: string;
  source: FormFieldDefinition;
};

export type FieldEditorSubmit = Omit<ArticleTypeConfigField, 'id'>;

export type FieldEditorModalState = {
  isOpen: boolean;
  mode: 'add' | 'edit';
  rowId?: string;
};

export type FieldFormValues = {
  sourceFieldName: string;
  field: string;
  kind: string;
  required: boolean;
  dependentField: string;
  validationValues: Record<string, string | boolean>;
  allowedFileFormats: string[];
  labelTitle: string;
  labelSubtitle: string;
  showHelpText: boolean;
  labelHelpText: string;
  labelContent: string;
};

export const EMPTY_FIELD_FORM: FieldFormValues = {
  sourceFieldName: '',
  field: '',
  kind: '',
  required: false,
  dependentField: '',
  validationValues: {},
  allowedFileFormats: [],
  labelTitle: '',
  labelSubtitle: '',
  showHelpText: false,
  labelHelpText: '',
  labelContent: ''
};
